import request from '../../request'
import { UseQueryResult, useQuery } from 'react-query'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'

type ResultType = {
  date: string
  impressions: number
  clicks: number
  rsv: number
  ctr: number
  vtr: number
  video_starts: number

  // Video metrics
  video_impressions: number
  video_completions: number
  video_first_quartile_completions: number
  video_second_quartile_completions: number
  video_third_quartile_completions: number

  // Audio metrics
  audio_impressions: number
  audio_completions: number
  audio_first_quartile_completions: number
  audio_second_quartile_completions: number
  audio_third_quartile_completions: number
}

export const useGetAgencyMetrics = ({
  agency_id,
  filters,
}: {
  agency_id: number
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType[], Error> => {
  const queryParams = useBuildQueryParams(filters)
  return useQuery<ResultType[], Error>(
    ['agencies', 'profile', 'reports', 'campaigns', 'metrics', { queryParams }],
    ({ signal }) =>
      request({
        url: `/agencies/${agency_id}/reports/campaigns/metrics`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }),
    {
      enabled: !!agency_id,
      keepPreviousData: true,
    },
  )
}
